import {
  addDisplayName,
  addProps,
  addState,
  addWrapper,
  flowMax,
  SimpleUnchangedProps,
} from 'ad-hok'
import { createUseStyles } from 'react-jss'
import { Helmet } from 'react-helmet-async'
import { addEffectOnUnmount } from 'ad-hok-utils'
import { FC } from 'react'

import { addWindowSize } from './addWindowSize'

const useStyles = createUseStyles<
  string,
  {
    windowHeight: number
  }
>({
  locked: {
    overflow: 'hidden',
    height: ({ windowHeight }) => windowHeight - 1,
    '& body': {
      overflow: 'hidden',
      height: ({ windowHeight }) => windowHeight - 1,
    },
  },
})

export const addBodyScrollLockingWhileMounted: SimpleUnchangedProps = flowMax(
  addState('_windowScrollYOnMount', '_', () => window.scrollY),
  addEffectOnUnmount(
    ({ _windowScrollYOnMount: windowScrollYOnMount }) =>
      () => {
        window.scrollTo(0, windowScrollYOnMount)
      }
  ),
  addWindowSize,
  addProps(({ windowHeight }) => ({
    _classes: useStyles({ windowHeight }),
  })),
  addWrapper((render, { _classes: classes }) => (
    <>
      <Helmet>
        <html className={classes.locked} />
        {/*<body className={classes.locked} />*/}
      </Helmet>
      {render()}
    </>
  ))
)

export const BodyScrollLock: FC = flowMax(
  addDisplayName('BodyScrollLock'),
  addBodyScrollLockingWhileMounted,
  () => null
)
